import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const UbsEntityIdSchema = z.string().min(1).brand('ubs-entity')
export type UbsEntityId = ZodInfer<typeof UbsEntityIdSchema>

export const UbsEntityId = (value: string) => {
  return UbsEntityIdSchema.parse(value)
}
